<template>
  <section
    v-if="isVisible"
    data-test-alert-main
    class="lb-portal alert-banners"
    data-test-component="alert"
  >
    <alert-banner
      v-for="alert in alerts"
      :key="alert.id"
      data-test-alert-main-banners
      :alert="alert"
    />
  </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import Utility from '@/common/UtilityFunctions.js';
import RequestService from '@/common/requestService';
import { AlertBannersData, AlertsViewModel } from './types/Alert';
import AlertBanner from './AlertBanner.vue';

export default defineComponent({
  name: 'Alert',
  components: {
    AlertBanner
  },
  props: {
    datasource: {
      type: String,
      default: () => ''
    }
  },
  data(): AlertBannersData {
    return {
      alerts: []
    };
  },
  computed: {
    isVisible(): boolean {
      return this.alerts && this.alerts.length > 0;
    }
  },
  mounted() {
    this.getViewModel();
  },
  methods: {
    async getViewModel(): Promise<void> {
      await RequestService.get<AlertsViewModel>(
        `${Utility.constants().API.alert_get}/${this.datasource}`
      )
        .then((response) => {
          const responseModel = response.data;

          this.alerts = responseModel.alerts.map((alertResponse) => ({
            id: alertResponse.id,
            title: alertResponse.title,
            body: alertResponse.body,
            startTime: alertResponse.startTime ? new Date(alertResponse.startTime) : undefined,
            endTime: alertResponse.endTime ? new Date(alertResponse.endTime) : undefined,
            link: alertResponse.link
          }));
        })
        .catch((err) => Utility.logError(err, this));
    }
  }
});
</script>
../../../../common/requestService
